import { Box, Button, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';
import { DexRegionEnum } from '@mark43/cad-api';
import { MaLeapsPassword } from '../../data-exchange/components/ma-leaps-password';
import { NotificationCounter } from '../../common/components/notification-counter';
import { useDexPasswordApi } from '../../data-exchange/use-dex-password-api';
import { useLogout } from '../../common/hooks/use-logout';
import { useQuit } from '../../common/hooks/use-quit';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function InitialsMenu(): React.ReactElement {
    const { isElectron } = useApplicationType();
    const { userProfileView: userProfile, dexRegion } = useBootstrapState();
    const isMADexRegion = dexRegion === DexRegionEnum.MA_LEAPS.name;
    const initials = `${userProfile.firstName[0]}${userProfile.lastName[0]}`.toLocaleUpperCase();
    const modalControls = useFullscreenModalControls();
    const leapsPasswordInfo = useDexPasswordApi();
    const shouldShowBadge = isMADexRegion && !leapsPasswordInfo.doesHavePassword;
    const logout = useLogout();
    const quit = useQuit();

    return (
        <Menu>
            <MenuTrigger data-testid="initials-menu" asChild>
                <Box mr={3}>
                    <Button variant="ghost" rightIcon="TriangleDown">
                        {shouldShowBadge && (
                            <Box mr={2}>
                                <NotificationCounter button="dex-password" isUrgent={true}>
                                    {1}
                                </NotificationCounter>
                            </Box>
                        )}

                        {initials}
                    </Button>
                </Box>
            </MenuTrigger>

            <MenuContent align="end" collisionPadding={0}>
                <MenuItem
                    onSelect={() => {
                        modalControls.open({
                            type: 'PREFERENCES',
                            props: {},
                        });
                    }}
                >
                    Preferences
                </MenuItem>

                {isMADexRegion && <MaLeapsPassword leapsPasswordInfo={leapsPasswordInfo} />}

                <MenuItem onSelect={logout}>Log Out</MenuItem>

                {isElectron && <MenuItem onSelect={quit}>Quit</MenuItem>}
            </MenuContent>
        </Menu>
    );
}
